import { authManager } from 'common/authManager'
import { useContext } from 'react'
import TopNavigationContext from './TopNavigationContext'
import { Box, Divider, Stack } from '@mui/material'

function TopNavigationHeader() {
  const context = useContext(TopNavigationContext)

  if (!authManager.isAuthenticated()) {
    return null
  }

  return (
    <Stack
      sx={{
        zIndex: 1,
        top: 0,
        width: '100%',
      }}
    >
      <Box pl={2} pt={2} pr={2} pb={2}>
        {context.currentState?.children}
      </Box>
      <Divider />
    </Stack>
  )
}

export default TopNavigationHeader
